import {
  createClient,
  cacheExchange,
  fetchExchange,
  mapExchange,
  subscriptionExchange,
} from "@urql/vue";
import { createConsumer } from "@rails/actioncable";
import SubscriptionExchange from "graphql-ruby-client/subscriptions/SubscriptionExchange";
import cookie from "./utilities/cookie.js";
import { logOut } from "./session.js";
import { pipe, map } from "wonka";

const actionCable = createConsumer(
  `${process.env.VUE_APP_WEBSOCKET_ENDPOINT}/cable?app=dashboard`
);

const forwardToActionCable = SubscriptionExchange.create({
  consumer: actionCable,
  channelName: "SlDashboardChannel",
});

const getOperationName = (operation) => {
  const definitions = operation.query?.definitions;
  const opDef = definitions?.find((def) => def.kind === "OperationDefinition");
  return opDef?.name?.value || "Unnamed";
};

const suppress401Exchange =
  ({ forward }) =>
  (ops$) =>
    pipe(
      forward(ops$),
      map((result) => {
        if (
          result?.error?.networkError?.status === 401 ||
          result?.error?.response?.status === 401
        ) {
          if (cookie.getSecureCookie("mulah_id") !== false) {
            let operationName = getOperationName(result.operation);
            operationName =
              operationName.charAt(0).toLowerCase() + operationName.slice(1);
            alert(
              "Your session has timed out due to inactivity or signing in on another device. Please log in again to continue."
            );
            logOut();
            return {
              operation: result.operation,
              data: {
                [operationName]: {
                  result: "OK",
                },
              },
              error: undefined,
              extensions: undefined,
            };
          }
        }

        return result;
      })
    );

export const client = createClient({
  url: process.env.VUE_APP_BACKEND_URI,
  exchanges: [
    mapExchange({
      onError(error) {
        if (`${error}`.match(/Deactivated/)) {
          localStorage.setItem("brandDeactivated", "true");
        } else {
          localStorage.setItem("brandDeactivated", "false");
        }
      },
    }),
    suppress401Exchange,
    cacheExchange,
    fetchExchange,
    subscriptionExchange({
      forwardSubscription: forwardToActionCable,
    }),
  ],
  requestPolicy: "network-only",
  fetchOptions: () => {
    return {
      headers: {
        app: "dashboard",
      },
      credentials: "include",
    };
  },
});

export const nlClient = createClient({
  url: process.env.VUE_APP_PUBLIC_BACKEND_URI,
  exchanges: [cacheExchange, fetchExchange],
  requestPolicy: "network-only",
  fetchOptions: () => {
    return {
      headers: {
        app: "dashboard",
      },
      credentials: "include",
    };
  },
});
